import { cn } from '../lib/utils';
import { CRITTERS } from '../lib/critters';

const initials = (name) =>
  (name ? name.split(' ').map((w) => w[0]).join('').slice(0, 2).toUpperCase() : '?');

// One pixel critter as an SVG; `kind` is a key of CRITTERS.
export function CritterIcon({ kind, className, label }) {
  const c = CRITTERS[kind];
  if (!c) return null;
  return (
    <svg viewBox="0 0 10 10" shapeRendering="crispEdges" className={cn('shrink-0', className)} role="img" aria-label={label || c.label}>
      <title>{label || c.label}</title>
      <rect width="10" height="10" rx="2" fill={c.tile} />
      {c.rows.flatMap((row, y) => [...row].map((ch, x) => (
        ch === '.' ? null : <rect key={`${x}-${y}`} x={x} y={y} width="1" height="1" fill={c.palette[ch]} />
      )))}
    </svg>
  );
}

// A square avatar (size via className, e.g. "h-4 w-4"). The person's chosen
// pixel critter, else their uploaded picture, else initials. Both come from
// the API (avatar_critter / avatar_url) and are managed on the team page.
export default function UserAvatar({ user, className, title }) {
  const label = title ?? user?.name ?? user?.username ?? '';
  if (user?.avatar_critter && CRITTERS[user.avatar_critter]) {
    return <CritterIcon kind={user.avatar_critter} className={className} label={label} />;
  }
  const src = user?.avatar_url || user?.avatar;
  if (src) {
    return <img src={src} alt={label} title={label} className={cn('shrink-0 rounded-full object-cover', className)} />;
  }
  return (
    <span
      className={cn('flex shrink-0 items-center justify-center rounded-full bg-primary/15 text-[9px] font-semibold text-primary', className)}
      title={label}
    >
      {initials(user?.name || user?.username)}
    </span>
  );
}
